// Thu Mar 27 06:04:37 GMT 2025

import * as models from "../crm-web-api-models"

export enum TBARequestProp {
	ConversionRate = 'conversionRate',
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	Description = 'description',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	OperationStatus = 'operationStatus',
	ProcessingType = 'processingType',
	Source = 'source',
	SourceCurrency = 'source.currency',
	SourceCustomer = 'source.customer',
	SourceCustomerId = 'source.customer.id',
	SourceAmount = 'sourceAmount',
	Status = 'status',
	Target = 'target',
	TargetCurrency = 'target.currency',
	TargetAmount = 'targetAmount',
	TransactionProcessingType = 'transactionProcessingType'
}

export type TBARequestPropConversionRate = {
	[TBARequestProp.ConversionRate] : number | null
}
export type TBARequestPropCreatedBy = {
	[TBARequestProp.CreatedBy] : models.UserDto | null
}
export type TBARequestPropCreationTime = {
	[TBARequestProp.CreationTime] : number | null
}
export type TBARequestPropDescription = {
	[TBARequestProp.Description] : string | null
}
export type TBARequestPropId = {
	[TBARequestProp.Id] : number
}
export type TBARequestPropModificationTime = {
	[TBARequestProp.ModificationTime] : number | null
}
export type TBARequestPropModifiedBy = {
	[TBARequestProp.ModifiedBy] : models.UserDto | null
}
export type TBARequestPropOperationStatus = {
	[TBARequestProp.OperationStatus] : string | null
}
export type TBARequestPropProcessingType = {
	[TBARequestProp.ProcessingType] : 'MANUAL' | 'AUTO' | null
}
export type TBARequestPropSource = {
	[TBARequestProp.Source] : models.DefaultEntityDto | null
}
export type TBARequestPropSourceCurrency = {
	[TBARequestProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type TBARequestPropSourceCustomer = {
	[TBARequestProp.SourceCustomer] : models.DefaultEntityDto | null
}
export type TBARequestPropSourceCustomerId = {
	[TBARequestProp.SourceCustomerId] : number | null
}
export type TBARequestPropSourceAmount = {
	[TBARequestProp.SourceAmount] : number | null
}
export type TBARequestPropStatus = {
	[TBARequestProp.Status] : 'NEW' | 'COMPLETED' | 'PENDING_FUNDS_REMOVAL' | 'PENDING_BALANCE_UPDATE' | 'FUNDS_REMOVED' | 'REJECTED' | 'FAILED' | null
}
export type TBARequestPropTarget = {
	[TBARequestProp.Target] : models.DefaultEntityDto | null
}
export type TBARequestPropTargetCurrency = {
	[TBARequestProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type TBARequestPropTargetAmount = {
	[TBARequestProp.TargetAmount] : number | null
}
export type TBARequestPropTransactionProcessingType = {
	[TBARequestProp.TransactionProcessingType] : 'ADJUSTMENT_BASED' | 'DEPOSIT_BASED' | null
}


export type TBARequest = 
	TBARequestPropConversionRate & 
	TBARequestPropCreatedBy & 
	TBARequestPropCreationTime & 
	TBARequestPropDescription & 
	TBARequestPropId & 
	TBARequestPropModificationTime & 
	TBARequestPropModifiedBy & 
	TBARequestPropOperationStatus & 
	TBARequestPropProcessingType & 
	TBARequestPropSource & 
	TBARequestPropSourceCurrency & 
	TBARequestPropSourceCustomer & 
	TBARequestPropSourceCustomerId & 
	TBARequestPropSourceAmount & 
	TBARequestPropStatus & 
	TBARequestPropTarget & 
	TBARequestPropTargetCurrency & 
	TBARequestPropTargetAmount & 
	TBARequestPropTransactionProcessingType

export const T_B_A_REQUEST_PROPERTY_NAMES = Object.freeze([TBARequestProp.ConversionRate, TBARequestProp.CreatedBy, TBARequestProp.CreationTime, TBARequestProp.Description, TBARequestProp.Id, TBARequestProp.ModificationTime, TBARequestProp.ModifiedBy, TBARequestProp.OperationStatus, TBARequestProp.ProcessingType, TBARequestProp.Source, TBARequestProp.SourceCurrency, TBARequestProp.SourceCustomer, TBARequestProp.SourceCustomerId, TBARequestProp.SourceAmount, TBARequestProp.Status, TBARequestProp.Target, TBARequestProp.TargetCurrency, TBARequestProp.TargetAmount, TBARequestProp.TransactionProcessingType])

export type TBARequestTab = 
	TBARequestPropId & 
	TBARequestPropSourceCustomerId

export const T_B_A_REQUEST_TAB_PROPERTY_NAMES = Object.freeze([TBARequestProp.Id, TBARequestProp.SourceCustomerId])

export type TBARequestHistoryTab = 
	TBARequestPropId

export const T_B_A_REQUEST_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([TBARequestProp.Id])

export type TBARequestHeader = 
	TBARequestPropId & 
	TBARequestPropSourceCustomer & 
	TBARequestPropTarget & 
	TBARequestPropTargetCurrency & 
	TBARequestPropTargetAmount

export const T_B_A_REQUEST_HEADER_PROPERTY_NAMES = Object.freeze([TBARequestProp.Id, TBARequestProp.SourceCustomer, TBARequestProp.Target, TBARequestProp.TargetCurrency, TBARequestProp.TargetAmount])

export type TBARequestInformation = 
	TBARequestPropId & 
	TBARequestPropCreationTime & 
	TBARequestPropCreatedBy & 
	TBARequestPropModificationTime & 
	TBARequestPropModifiedBy & 
	TBARequestPropSourceCustomer & 
	TBARequestPropStatus & 
	TBARequestPropProcessingType & 
	TBARequestPropOperationStatus & 
	TBARequestPropTransactionProcessingType

export const T_B_A_REQUEST_INFORMATION_PROPERTY_NAMES = Object.freeze([TBARequestProp.Id, TBARequestProp.CreationTime, TBARequestProp.CreatedBy, TBARequestProp.ModificationTime, TBARequestProp.ModifiedBy, TBARequestProp.SourceCustomer, TBARequestProp.Status, TBARequestProp.ProcessingType, TBARequestProp.OperationStatus, TBARequestProp.TransactionProcessingType])

export type TBARequestDetails = 
	TBARequestPropDescription

export const T_B_A_REQUEST_DETAILS_PROPERTY_NAMES = Object.freeze([TBARequestProp.Description])

export type TBARequestAmount = 
	TBARequestPropSource & 
	TBARequestPropSourceCurrency & 
	TBARequestPropSourceAmount & 
	TBARequestPropTarget & 
	TBARequestPropTargetCurrency & 
	TBARequestPropTargetAmount & 
	TBARequestPropConversionRate & 
	TBARequestPropStatus

export const T_B_A_REQUEST_AMOUNT_PROPERTY_NAMES = Object.freeze([TBARequestProp.Source, TBARequestProp.SourceCurrency, TBARequestProp.SourceAmount, TBARequestProp.Target, TBARequestProp.TargetCurrency, TBARequestProp.TargetAmount, TBARequestProp.ConversionRate, TBARequestProp.Status])
